/** @jsxImportSource @emotion/react */
import { useState } from 'react'
import NavigationBar from 'apollo-react/components/NavigationBar'
import Typography from 'apollo-react/components/Typography'
import IDSThemeProvider from 'apollo-react/utils/IDSThemeProvider'
import Avatar from 'apollo-react/components/Avatar'
import SettingsIcon from 'apollo-react-icons/Cog'
import UserIcon from 'apollo-react-icons/User'
import NotesDiary from 'apollo-react-icons/NotesDiary'
import Styles from './IDSHeaderStyle'

const accountSettingsUrl = () => {
  let host = window.location.host.split('.')
  host[0] = 'platform'
  return `${window.location.protocol}//${host.join('.')}/r/account/settings/`
}

const userGuidesUrl = () => {
  let host = window.location.host.split('.')
  host[0] = 'platform'
  return `${window.location.protocol}//${host.join('.')}/r/user_guides/`
}
const isTenantZero = window.location.hostname
  .toLowerCase()
  .startsWith('platform')

const profileMenuProps = {
  name: '',
  title: '',
  email: '',
  logoutText: 'Log out',
  icon: <Avatar size="small" title="" stateless></Avatar>,
  menuItems: [
    {
      text: 'Account Settings',
      icon: UserIcon,
      onClick: () => {
        window.location.href = accountSettingsUrl()
      },
    },
    ...(!isTenantZero
      ? [
          {
            text: 'User Guides',
            icon: NotesDiary,
            onClick: () => {
              window.open(userGuidesUrl(), '_blank', 'noopener,noreferrer')
            },
          },
        ]
      : []),
    {
      text: 'Support',
      icon: SettingsIcon,
      onClick: () => {
        window.location.href = `${window.location.protocol}//${window.location.host}/feedback_messages/new/`
      },
    },
  ],
}

const IDSHeaderEmbed = ({
  hasProfileImage,
  largeProfileImageUrl,
  name,
  email,
}) => {
  const navClick = ({ text }) => {
    setSelectedMenuItem(text)
  }

  const iconComponent = hasProfileImage ? (
    <Avatar src={largeProfileImageUrl} size="small" />
  ) : (
    <Avatar size="small" title={''} stateless></Avatar>
  )

  const logout = () => {
    window.location.href = window.location.origin + '/logout/'
  }

  const navClickHome = () => {
    let host = window.location.host.split('.')
    host[0] = 'platform'
    window.location.href = `${window.location.protocol}//${host.join('.')}/r/`
  }

  const [selectedMenuItem, setSelectedMenuItem] = useState('')
  return (
    <IDSThemeProvider themeName="IDS">
      <NavigationBar
        LogoComponent={() => (
          <Typography sx={Styles.logoStyle}>
            IQVIA{' '}
            <span
              style={{
                fontWeight: 725,
                marginLeft: '10px',
                cursor: 'pointer',
              }}
              onClick={navClickHome}
            >
              {' '}
              Investigator Site Portal
            </span>
          </Typography>
        )}
        waveVariant={'right'}
        noGradient={false}
        variant={'brand'}
        onClick={navClick}
        menuItems={[]}
        showMenuIcon={false}
        checkIsActive={item => {
          return item.menuItems
            ? item.menuItems.some(item => item.text === selectedMenuItem)
            : item.text === selectedMenuItem
        }}
        profileMenuProps={{
          ...profileMenuProps,
          style: { fontWeight: '600' },
          name: name,
          email: email,
          logoutButtonProps: {
            onClick: logout,
          },
          icon: iconComponent,
        }}
      />
    </IDSThemeProvider>
  )
}

export default IDSHeaderEmbed
